import { SearchInfoService } from "data/service/search-info-service";
import { Item, AppUserInfo } from "data/entities/entities";
import { autoinject, observable, LogManager, computedFrom } from 'aurelia-framework';
import { ItemTypes, CloseStatuses } from 'core/enums';
import { MetadataService } from 'data/service/meta-data-service';
import { Subscription, EventAggregator } from 'aurelia-event-aggregator';
import { AppEvents } from 'core/app-events';
import { AppStateService } from 'data/service/app-state-service';
import { SearchInput } from 'data/entities/input/searchInput';
import { ItemTypeBase } from 'data/entities/item-type-base';
import { AppUserInfoService } from '../../data/service/app-user-info-service';

@autoinject()
export class Search {
	async search() {
		this.items = [];
		this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, true);
		this.item.entityStatusCode = this.selectedEntityStatusCode;
		this.item.searchTypeCode = this.selectedSearchTypeCode;
		this.saveSearch();
		const items = await this.service.search(this.item);
		items.forEach((item: Item) => {
			item.showDetails = this.appUserInfo.isSearchResultPanel;
			this.items._add(item)
		});
		this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, false);
		if (this.items.length === 0) {
			this.message = "Sorry, I looked, but found nothing.";
			this.setMessageTimeout();
		}
	}

	saveSearch() {
		this.appStateService.saveState(this.className, 'item', this.item, true);
	}

	@computedFrom('item.itemStatusId', 'item.assignedToId', 'item.ownedById', 'item.tagId', 'item.searchString')
	get canSearch() {
		this.logger.info('dirty Checking canSearch');
		return (
			this.item.itemStatusId ||
				this.item.assignedToId ||
				this.item.ownedById ||
				this.item.tagId ||
				this.item.id ||
				this.item.processStepId ||
				this.item.searchString
				? true : false);
	}

	message = '';
	@observable selectedEntityStatusCode = 'ACTIVE';
	@observable selectedSearchTypeCode = 'MATCH_WORD';
	className = 'Search'
	logger = LogManager.getLogger(this.className);
	items: Array<Item>;
	item: SearchInput = new SearchInput();
	myKeypressCallback: any;
	isInitialized = false;
	appUserInfo: AppUserInfo;

	constructor(private service: SearchInfoService,
		private eventAggregator: EventAggregator,
		private appStateService: AppStateService,
		private appUserInfoService: AppUserInfoService,
		private metadataService: MetadataService
	) {
		this.logger.info("Constructor");
		this.myKeypressCallback = (e: KeyboardEvent) => {
			this.logger.info(e.keyCode.toString());
			if (e.keyCode === 13) {
				this.search();
			}
		};
	}

	selectedEntityStatusCodeChanged() {
		if (!this.isInitialized) return;
		this.logger.info('selectedEntityStatusCodeChanged');
		this.appStateService.saveState(this.className, 'selectedEntityStatusCode', this.selectedEntityStatusCode);
	}

	selectedSearchTypeCodeChanged() {
		if (!this.isInitialized) return;
		this.logger.info('selectedSearchTypeCodeChanged');
		this.appStateService.saveState(this.className, 'selectedSearchTypeCode', this.selectedSearchTypeCode);
	}

	private unsubscribeFromEvents() {
		for (const entry of this.eventSubscriptions) {
			entry.dispose();
		}
		this.eventSubscriptions = [];
	}

	deactivate() {
		this.unsubscribeFromEvents();
		window.removeEventListener('keypress', this.myKeypressCallback);
	}

	subscribeToEvents() {
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.DIRECTORY_CHANGED, payload => {
			this.onDirectoryChanged(payload);
		}));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.MetadataAcquired, payload => {
			this.onMetadataAcquired(payload);
		}));
	}

	onDirectoryChanged(payload: any): any {
		this.items = [];
		this.logger.debug('EntityStatus Count: ' + this.metadataService.entityStatuses.length.toString());
	}

	eventSubscriptions: Array<Subscription> = [];

	async activate() {
		this.subscribeToEvents();
		this.appUserInfo = await this.appUserInfoService.getCurrentAppUserInfo();
		await this.initialize();
	}

	onMetadataAcquired(payload) {
		this.initialize();
	}

	itemStatuses: ItemTypeBase[];
	appUsers: any;
	tags: any;
	processSteps: ItemTypeBase[];

	bindDataSources() {
		this.itemStatuses = this.metadataService.itemStatuses;
		this.appUsers = this.metadataService.appUsers;
		this.tags = this.metadataService.tags;
		this.processSteps = this.metadataService.processSteps;
	}

	async initialize() {
		//if (this.isInitialized) return;
		if (!this.metadataService.isInitialized) return;//If no metadata, wait for the event to initialize.		
		this.appStateService.setAppState(this.className, this);
		this.item.itemTypeId = ItemTypes.Task;
		this.item.closeStatusId = CloseStatuses.Open;
		this.logger.info("Activate");
		window.addEventListener('keypress', this.myKeypressCallback, false);
		this.bindDataSources()
		this.isInitialized = true;
	}

	clear() {
		this.items = null;
		this.item.searchString = null;
		this.item.itemStatusId = null;
		this.item.assignedToId = null;
		this.item.ownedById = null;
		this.item.tagId = null;
		this.item.id = null;
		this.message = '';
	}

	validateSearch() {
		let isValid = false;
		if (this.item.itemStatusId) isValid = true;
		return isValid;
	}

	setMessageTimeout() {
		window.setTimeout(() => this.message = '', 3000);
	}
}
